<template>
	<create-edit-layout v-if="showCreateEditAttachment" element="Attachment" icon="fas fa-paperclip" @duplicatecomplete="$emit('duplicatecomplete')">
		<v-col cols="12" xs="12" align="right">
			<download-attachment action="download" :element="currentAttachment"></download-attachment>
		</v-col>
		<v-col cols="12" xs="12" sm="6" class="pb-0">
			<v-sheet v-if="!currentAttachment.link">
				<v-skeleton-loader type="image"></v-skeleton-loader>
			</v-sheet>
			<v-img v-else-if="currentAttachment.thumbnail_link" :src="currentAttachment.thumbnail_link" contain @click="$functions.openLink(currentDisplayAttachment.link)" max-height="330" class="clickarea">
				<template v-slot:placeholder>
					<v-sheet>
						<v-skeleton-loader type="image"></v-skeleton-loader>
					</v-sheet>
				</template>
			</v-img>
			<v-card v-else outlined @click="currentAttachmentModel.id ? downloadOrViewAttachment() : null">
				<v-card-text v-intersect="loadAttachmentPreview()">
					<v-row class="d-flex flex-column" dense align="center" justify="center">
						<v-icon class="mt-5 mb-3" size="60">fas fa-hat-wizard</v-icon>
						<v-progress-linear indeterminate height="25">
							<strong>{{ $t("attachment.preview_loading") }}</strong>
						</v-progress-linear>
					</v-row>
				</v-card-text>
			</v-card>
			<!--
            <v-card v-else outlined @click="downloadOrViewAttachment()">
                <v-card-text>
                    <v-row class="d-flex flex-column" dense align="center" justify="center">
                        <v-icon class='mt-5' size="60">{{$functions.iconFromFileType(currentAttachment.filetype)}}</v-icon>
                        <p>{{$t('attachment.clik_to_open')}}</p>
                    </v-row>
                </v-card-text>
            </v-card>-->
		</v-col>
		<v-col cols="12" xs="12" sm="6">
			<v-row dense>
				<v-col cols="12" xs="12">
					<ValidationProvider ref="title" vid="title" :name="$t('attachment.file_title')" rules="required|max:100" v-slot="{ errors, field }">
						<v-text-field class="required" :label="$t('attachment.file_title')" v-model="currentAttachment.title" :error-messages="errors"></v-text-field>
					</ValidationProvider>
				</v-col>
				<v-col cols="12" xs="12" :sm="hasCategorySelection ? 6 : 12">
					<ValidationProvider ref="filename" vid="filename" :name="$t('attachment.filename')" rules="required" v-slot="{ errors, field }">
						<v-text-field class="required" :label="$t('attachment.filename')" v-model="currentAttachment.filename" :error-messages="errors"></v-text-field>
					</ValidationProvider>
				</v-col>
				<v-col cols="12" xs="12">
					<ValidationProvider ref="description" vid="description" :name="$t('attachment.file_description')" rules="max:255" v-slot="{ errors, field }">
						<v-text-field :label="$t('attachment.file_description')" v-model="currentAttachment.description" :error-messages="errors"></v-text-field>
					</ValidationProvider>
				</v-col>
			</v-row>
		</v-col>
	</create-edit-layout>
</template>

<script>
export default {
	data: () => ({
		selfpreview_loading: false,
		loadPreviewTimeout: null,
	}),
	computed: {
		showCreateEditAttachment() {
			return this.$store.getters.showCreateEditAttachment;
		},
		currentAttachment: {
			get: function () {
				return this.$store.getters.getCurrentAttachment;
			},
			set: function (value) {
				this.$store.commit("setCurrentAttachment", value);
			},
		},
		attachmentCategory() {
			return this.$store.getters.getAttachmentCategory;
		},
		isAdminCategory() {
			return this.$store.getters.isAdminCategory;
		},
		hasCategorySelection() {
			if (this.attachmentCategory == "associates") {
				return true;
			}
			return false;
		},
		attachmentpreview_loading() {
			return this.$store.getters.attachmentpreview_loading;
		},
	},
	methods: {
		loadAttachmentPreview() {
			const self = this;
			if (!self.selfpreview_loading) {
				if (self.currentAttachment.thumbnail_link) {
				} else {
					if (!self.attachmentpreview_loading) {
						self.selfpreview_loading = true;

						self.$store.dispatch("loadAttachmentPreview", self.currentAttachment.id);
					}
					self.loadPreviewTimeout = setTimeout(function () {
						self.selfpreview_loading = false;
						self.loadAttachmentPreview();
					}, 5000);
				}
			}
		},
		downloadOrViewAttachment() {
			if (this.currentDisplayAttachment.link && params.action == "view") {
				this.$functions.openLink(this.currentDisplayAttachment.link);
			} else {
				this.$functions.openLink(this.currentDisplayAttachment.link, "download", this.currentDisplayAttachment.filename);
			}
		},
	},
	beforeDestroy() {
		clearTimeout(this.loadPreviewTimeout);
	},
};
</script>
